import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Dashboard from "./components/dashboard";
import HowItWorks from "./components/howItWorks";
import FaqSection from "./components/faqSection";
import ReadyToSend from "./components/readyToSend";
import Footer from "./components/footer";
import ContactPage from "./components/contactPage";
import PrivacyPolicy from "./components/privacyPolicy";
import TermsOfUsePage from "./components/termsOfUse";
import BecomePartner from "./components/becomePartner";
import AppRedirect from "./components/appRedirect";
import AdminLoginScreen from "./admin/adminLogin"; // ✅ fixed import path
import AdminSignupScreen from "./admin/adminSignup"; // ✅ fixed import path
import CreateProfileScreen from "./admin/createProfile"; // ✅ fixed import path
import CreatePasswordScreen from "./admin/createPassword"; // ✅ fixed import path
import VerifyEmailScreen from "./admin/verifyEmail";
import AdminDashboard from "./admin/adminDashboard"; // ✅ fixed import path
import ProtectedRoute from "./components/ProtectedRoute";
import GuestRoute from "./components/GuestRoute";
import { USER_TYPES } from "./contexts/AuthContext";
// Admin Dashboard Components
import AdminDashboardHome from "./admin/components/Dashboard";
import BusinessProfileDetail from "./admin/components/BusinessProfileDetail";
import Profile from "./admin/components/Profile";
import PaymentInfo from "./admin/components/PaymentInfo";
import UpdatePayment from "./admin/components/UpdatePayment";
import ClaimBeer from "./admin/components/ClaimBeer";
import Consumers from "./admin/components/Consumers";
import DailyView from "./admin/components/DailyView";
import Reports from "./admin/components/Reports";
import Notifications from "./admin/components/Notifications";
// import AdminAppBar  from './admin/adminAppbar'; // ✅ fixed import path
import PartnerAgreement from "./admin/partnerAgreement";
import QrCodeClaimPage from "./components/qrCodeClaimPage";
import StagingQrRedirect from "./components/stagingQrRedirect";
import SessionCountdownBanner from "./components/SessionCountdownBanner";
import ScrollToTop from "./components/ScrollToTop";
import SupportLocal from "./components/supportLocal";

function App() {
  const location = useLocation();

  return (
    <>
      {/* Every route change starts at the top of the screen it opened. AC-SCROLL-F1. */}
      <ScrollToTop />

      <Routes>
        {/* Home Page */}
        <Route
          path="/"
          element={
            <div>
              <Dashboard />
              <HowItWorks />
              <SupportLocal />
              <FaqSection />
              <ReadyToSend />
            </div>
          }
        />
        {/* Other Pages */}
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/become-a-partner" element={<BecomePartner />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-use" element={<TermsOfUsePage />} />
        <Route path="/app_redirect" element={<AppRedirect />} />
        <Route path="/qrcode" element={<QrCodeClaimPage />} />
        {/* Staging gift texts point here on www.myhoom.com so carriers never see the
            staging server's raw-IP hostname; this route forwards to staging. */}
        <Route path="/staging/qrcode" element={<StagingQrRedirect />} />
        <Route
          path="/admin-login"
          element={
            <GuestRoute>
              <AdminLoginScreen />
            </GuestRoute>
          }
        />
        <Route path="/admin-signup" element={<AdminSignupScreen />} />
        <Route path="/create-profile" element={<CreateProfileScreen />} />
        <Route path="/create-password" element={<CreatePasswordScreen />} />
        <Route path="/verify-email" element={<VerifyEmailScreen />} />
        <Route path="/partner-agreement" element={<PartnerAgreement />} />
        <Route
          path="/admin-dashboard"
          element={
            <ProtectedRoute
              allowedRoles={[USER_TYPES.BUSINESS_ADMIN, USER_TYPES.SUPER_ADMIN]}
            >
              <AdminDashboard />
            </ProtectedRoute>
          }
        >
          {/* Default route - Dashboard */}
          <Route index element={<AdminDashboardHome />} />
          {/* Business Profile Detail Route */}
          <Route
            path="businessProfiles/:id"
            element={
              <ProtectedRoute
                allowedRoles={[
                  USER_TYPES.BUSINESS_ADMIN,
                  USER_TYPES.SUPER_ADMIN,
                ]}
              >
                <BusinessProfileDetail />
              </ProtectedRoute>
            }
          />

          {/* Super Admin Routes */}
          <Route
            path="consumers"
            element={
              <ProtectedRoute allowedRoles={[USER_TYPES.SUPER_ADMIN]}>
                <Consumers />
              </ProtectedRoute>
            }
          />
          <Route
            path="daily-view"
            element={
              <ProtectedRoute allowedRoles={[USER_TYPES.SUPER_ADMIN]}>
                <DailyView />
              </ProtectedRoute>
            }
          />
          {/* Business Admin Routes */}
          <Route
            path="payment-info"
            element={
              <ProtectedRoute allowedRoles={[USER_TYPES.BUSINESS_ADMIN]}>
                <PaymentInfo />
              </ProtectedRoute>
            }
          />
          <Route
            path="profile"
            element={
              <ProtectedRoute
                allowedRoles={[
                  USER_TYPES.BUSINESS_ADMIN,
                  USER_TYPES.SUPER_ADMIN,
                ]}
              >
                <Profile />
              </ProtectedRoute>
            }
          />
          <Route
            path="redeem-beer"
            element={
              <ProtectedRoute allowedRoles={[USER_TYPES.BUSINESS_ADMIN]}>
                <ClaimBeer />
              </ProtectedRoute>
            }
          />
          <Route
            path="update-payment"
            element={
              <ProtectedRoute allowedRoles={[USER_TYPES.BUSINESS_ADMIN]}>
                <UpdatePayment />
              </ProtectedRoute>
            }
          />
          {/* Shared Routes */}
          <Route
            path="reports"
            element={
              <ProtectedRoute
                allowedRoles={[
                  USER_TYPES.BUSINESS_ADMIN,
                  USER_TYPES.SUPER_ADMIN,
                ]}
              >
                <Reports />
              </ProtectedRoute>
            }
          />
          <Route
            path="notifications"
            element={
              <ProtectedRoute
                allowedRoles={[
                  USER_TYPES.BUSINESS_ADMIN,
                  USER_TYPES.SUPER_ADMIN,
                ]}
              >
                <Notifications />
              </ProtectedRoute>
            }
          />
        </Route>
      </Routes>

      {/* Fixed session-cap countdown: shows in the final minutes on every route
          except the landing page, and signs the user out at zero. Mounted
          unconditionally — the route exclusion lives inside the component. */}
      <SessionCountdownBanner />

      {/* Footer only if not on admin pages */}
      {!location.pathname.startsWith("/admin") &&
        location.pathname !== "/become-a-partner" &&
        location.pathname !== "/qrcode" &&
        location.pathname !== "/staging/qrcode" && <Footer />}

      {/* Toast Container */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
}

export default App;
